module.exports = __webpack_public_path__ + "img/LogoCSA_Color.741afead.png";